import React, { useEffect, useState } from "react";
import "../components/AboutSection.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  MorphingDialog,
  MorphingDialogTrigger,
  MorphingDialogContainer,
  MorphingDialogContent,
  MorphingDialogClose,
  MorphingDialogTitle,
  MorphingDialogDescription,
  MorphingDialogImage,
} from './ui/MorphingDialog';
import { AnimatePresence } from "framer-motion";

const newsItems = [
  {
    source: "Canarias7",
    logo: "/img/canarias7.png",
    description: "El diario líder en el archipiélago destaca nuestra apuesta por la salud digital fusionando ciencia y videojuegos para ganar en salud.",
    links: [
      {
        title: "Una joven emprendedora grancanaria fusiona ciencia y videojuegos para ganar en salud",
        url: "https://www.canarias7.es/sociedad/ciencia/joven-emprededora-grancanaria-fusiona-ciencia-videojuegos-ganar-20250525181948-nt.html"
      },
      {
        title: "Educación apuesta por una FP conectada a la realidad productiva de Canarias",
        url: "https://www.canarias7.es/sociedad/educacion/educacion-apuesta-conectada-realidad-productiva-canarias-20260212190225-nt.html#vca=fixed-btn&vso=canarias7&vmc=wh&vli=sociedad"
      },
      {
        title: "La ULPGC impulsa y reconoce a 14 empresas basadas en conocimiento: 10 startups y 4 spinoffs",
        url: "https://www.canarias7.es/sociedad/educacion/ulpgc-impulsado-reconocido-empresas-basadas-conocimiento-startups-20250904133306-nt.html?ref=https%3A%2F%2Fwww.linkedin.com%2F"
      }
    ]
  },
  {
    source: "La Provincia",
    logo: "/img/laprovincia.png",
    description: "El histórico periódico grancanario analiza el potencial terapéutico de nuestros desarrollos y nuestra visión tecnológica con IA y neurociencia aplicada.",
    links: [
      {
        title: "Maica Amador: «Los videojuegos son una herramienta terapéutica muy potente»",
        url: "https://www.laprovincia.es/sociedad/2025/05/13/maica-amador-videojuegos-startup-ia-neurociencia-117359056.html"
      },
      {
        title: "Internacionalización: un paso estratégico para las pymes",
        url: "https://www.laprovincia.es/canarias/2025/11/22/internacionalizacion-paso-estrategico-pymes-bc-123989390.html"
      },
      {
        title: "Digion Canarias 2026 pone el foco en la transformación digital, la inteligencia artificial y la ciberseguridad",
        url: "https://www.laprovincia.es/gran-canaria/2026/03/03/digion-canarias-2026-pone-foco-127488235.html"
      },
      {
        title: "Videojuegos e inteligencia artificial para anticiparse al alzhéimer desde Canarias",
        url: "https://www.laprovincia.es/canarias/2026/05/23/videojuegos-inteligencia-artificial-anticiparse-alzheimer-130570528.html"
      }
    ]
  },
  {
    source: "Telenoticias (TVC)",
    logo: "/img/Logo_de_Television_Canaria.png",
    description: "La televisión pública canaria se hace eco de nuestros avances en neurociencia, salud y el futuro tecnológico que estamos construyendo.",
    links: [
      {
        title: "Telenoticias 1: Neurociencia y bienestar (20/05/25)",
        url: "https://www.youtube.com/watch?v=OI2icQW6XDg&list=PLHagRXzKHn2Nj-zDQAL4sc3Sx3OOtx-N0&index=5"
      },
      {
        title: "Telenoticias 2: Startup canaria Sparkling Tech (29/08/25)",
        url: "https://www.youtube.com/watch?si=Y6hQhrggluf7zRWV&v=Q9P-Q8LN1zE&feature=youtu.be"
      },
      {
        title: "Canarias futura | 08/03/26",
        url: "https://youtu.be/eWSafnUgvLI?si=cGt6jbEz8f4lykxc&t=2003"
      }
    ]
  },
  {
    source: "Plan B Group",
    logo: "/img/planbgroup.png",
    description: "Consultoría estratégica líder destaca nuestra trayectoria como proyecto innovador y nuestro papel en el ecosistema emprendedor.",
    links: [
      {
        title: "Maica Amador: «Plan B Group ha sido un socio estratégico recomendado»",
        url: "https://planbgroup.es/2025/03/maica-amador-sparkling-tech-solutions-futec-socios-viaje-recomiendo-persona-emprender/"
      }
    ]
  },
  {
    source: "Femepa",
    logo: "/img/femepa.png",
    description: "La federación empresarial destaca nuestra startup como un caso de éxito en la aplicación de tecnología para el impacto real.",
    links: [
      {
        title: "Caso de éxito: Sparkling Tech Solutions en el programa Acelera Pyme",
        url: "https://acelerapymefemepa.es/caso-de-exito-sparklingtech/"
      }
    ]
  },
  {
    source: "ULPGC",
    logo: "/img/ulpgc_corto.png",
    description: "Nuestra alma mater presenta nuestra incorporación como EBT especializada en neurociencia aplicada, IA y videojuegos.",
    links: [
      {
        title: "La nueva startup de la ULPGC especializada en neurociencia aplicada",
        url: "https://www.fpct.ulpgc.es/es/noticias/item/1238-sparkling-tech-solutions-la-nueva-startup-de-la-ulpgc-especializada-en-neurociencia-applied-ia-y-videojuegos.html"
      },
      {
        title: "Entrevista TVC a Maica Amador en la Biblioteca",
        url: "https://biblioteca.ulpgc.es/noticia-entrevista-tvc-a-maica-amador-en-la-biblioteca"
      },
      {
        title: "Sparkling Tech Solutions, startup de la ULPGC, incluida en el ranking «Top25 startups de IA a tener en cuenta para 2026»",
        url: "https://www.fpct.ulpgc.es/es/noticias/item/1302-sparkling-tech-solutions-startup-de-la-ulpgc-incluida-en-el-ranking-top25-startups-de-ia-a-tener-en-cuenta-para-2026.html"
      },
      {
        title: "El pódcast «Innovación abierta» destaca el papel de la ULPGC como motor de emprendimiento",
        url: "https://www.fpct.ulpgc.es/es/noticias/item/1317-el-podcast-innovacion-abierta-destaca-el-papel-de-la-ulpgc-como-motor-de-emprendimiento.html"
      },
      {
        title: "Sparkling Tech, finalista en los reconocimientos TOP101 Spain Up Nation 2025",
        url: "https://www.fpct.ulpgc.es/es/noticias/item/1275-alternative-circuits-y-sparkling-tech-empresas-basadas-en-el-conocimiento-de-la-ulpgc-finalistas-en-los-reconocimientos-top101-spain-up-nation-2025.html"
      },
      {
        title: "Sparkling Tech Solutions, startup ULPGC, ganadora del premio IP FEST",
        url: "https://otc.ulpgc.es/sparkling-tech-solutions-startup-ulpgc-ganadora-del-premio-ip-fest/#"
      },
      {
        title: "Mujeres en neurociencia: charla",
        url: "https://www.ulpgc.es/agenda/2026/02/12/mujeres-neurociencia-charla"
      },
      {
        title: '"Inspirando a futuras neurocientíficas": charla por el Día Internacional de la Mujer y la Niña en la Ciencia',
        url: "https://biblioteca.ulpgc.es/noticia-charla-mujeres-neurociencia"
      },
      {
        title: 'El pódcast «Innovación abierta» destaca el papel de la ULPGC como motor de emprendimiento',
        url: "https://www.fpct.ulpgc.es/es/noticias/item/1317-el-podcast-innovacion-abierta-destaca-el-papel-de-la-ulpgc-como-motor-de-emprendimiento.html"
      }
    ]
  },
  {
    source: "Tribuna de Canarias",
    logo: "/img/TribunaDeCanarias.png",
    description: "Tribuna de Canarias destaca nuestra participación en jornadas de expansión e internacionalización para pymes, impulsando el crecimiento en nuevos mercados.",
    links: [
      {
        title: "La Cámara de Comercio de Gran Canaria y BBVA celebraron la jornada Pymes en Expansión",
        url: "https://tribunadecanarias.es/la-camara-de-comercio-de-gran-canaria-y-bbva-celebraron-la-jornada-pymes-en-expansion-crecer-en-nuevos-mercados/"
      },
      {
        title: "Canarias refuerza su estrategia internacional de innovación con PROEXCA como eje de la proyección exterior en Transfiere 2026",
        url: "https://tribunadecanarias.es/canarias-refuerza-su-estrategia-internacional-de-innovacion-con-proexca-como-eje-de-la-proyeccion-exterior-en-transfiere-2026/"
      }
    ]
  },
  {
    source: "RNE",
    logo: "/img/rne.png",
    description: "Radio Nacional de España explora en Radio Exterior los avances e investigaciones de Sparkling Tech en salud y medioambiente.",
    links: [
      {
        title: "Informativo ARU: Innovación y ciencia en Sparkling Tech Solutions",
        url: "https://www.rtve.es/play/audios/informativo-aru-en-radio-exterior-de-espana/informativo-aru-ree-alimentacion-investigaciones-medioambiente/16621521/"
      }
    ]
  },
  {
    source: "RedCIDE",
    logo: "/img/RedCide.png",
    description: "La red de innovación destaca nuestras soluciones tecnológicas inmersivas como motor de cambio y accesibilidad.",
    links: [
      {
        title: "Soluciones tecnológicas inmersivas, inteligentes y accesibles",
        url: "https://www.redcide.es/casos-de-exito/item/610-soluciones-tecnologicas-inmersivas-inteligentes-y-accesibles"
      },
      {
        title: "Soluciones tecnológicas inmersivas, inteligentes y accesibles (vídeo)",
        url: "https://www.youtube.com/watch?v=I49Zw_35a9Y"
      }
    ]
  },
  {
    source: "Radio Agüimes",
    logo: "/img/radioaguimes.png",
    description: "Entrevista cercana en la radio local sobre el emprendimiento y el valor social de nuestra tecnología en las islas.",
    links: [
      {
        title: "Entrevista a Maica Amador sobre emprendimiento y bienestar",
        url: "https://www.ivoox.com/en/maica-amador-21-07-25-audios-mp3_rf_153457354_1.html"
      }
    ]
  },
  {
    source: "Gobierno de Canarias",
    logo: "/img/Logo_GobCan_color.png",
    description: "El ejecutivo canario nos sitúa como referentes en innovación que transforma Canarias y generacion de valor.",
    links: [
      {
        title: "La innovación que transforma Canarias: Casos de éxito generadores de valor",
        url: "https://www3.gobiernodecanarias.org/noticias/la-innovacion-que-transforma-canarias-casos-de-exito-generadores-de-valor/"
      },
      {
        title: "Cinco empresas canarias entre las finalistas Top101 Spain Up Nation",
        url: "https://www3.gobiernodecanarias.org/noticias/cinco-empresas-canarias-entre-las-finalistas-de-los-reconocimientos-top101-spain-up-nation-2025/"
      },
      {
        title: "Canarias refuerza su posicionamiento como plataforma atlántica de innovación en Málaga Transfiere 2026",
        url: "https://www3.gobiernodecanarias.org/noticias/canarias-refuerza-su-posicionamiento-como-plataforma-atlantica-de-innovacion-en-malaga-transfiere-2026/"
      }, {
        title: "Poli Suárez apuesta por una Formación Profesional planificada en conexión con la realidad productiva de Canarias",
        url: "https://www3.gobiernodecanarias.org/noticias/poli-suarez-apuesta-por-una-formacion-profesional-planificada-en-conexion-con-la-realidad-productiva-de-canarias/"
      },
    ]
  },
  {
    source: "Top 101 Spain Up Nation",
    logo: "/img/Sello-SUN-Top-101-Color-Horizontal_empresa-101.png",
    description: "Reconocimiento a nivel nacional entre las 101 startups con mayor impacto y potencial de España en el panorama actual.",
    links: [
      {
        title: "Listado de empresas Top 101 Spain Up Nation 2025",
        url: "https://www.top101spainupnation.com/empresas-top101-2025/"
      }
    ]
  },
  {
    source: "Devuego",
    logo: "/img/logo-devuego-principal-negro_min.png",
    description: "Medio especializado en la industria del videojuego y el desarrollo interactivo en España.",
    links: [
      {
        title: "Maica Amador Marrero es Miembro de Asociación Canaria de Desarrolladores de Videojuegos (ACADEVI).",
        url: "https://www.devuego.es/bd/fpersona/maica-amador-marrero"
      }
    ]
  },
  {
    source: "El Referente",
    logo: "/img/ElReferente.png",
    description: "Revista líder en innovación, startups y ecosistema emprendedor tecnológico.",
    links: [
      {
        title: "Sparkling Tech Solutions",
        url: "https://elreferente.es/startup/sparkling-tech-solutions/?refrc=1"
      },
      {
        title: "Top25 startups de IA a tener en cuenta para este 2026",
        url: "https://elreferente.es/startups/top25-startups-de-ia-a-tener-en-cuenta-para-este-2026/"
      }
    ]
  },
  {
    source: "ivoox",
    logo: "/img/ivoox.png",
    description: "Plataforma digital de referencia para la difusión de contenidos en audio y podcast.",
    links: [
      {
        title: "Emprender desde la Universidad: IA y calidad de vida",
        url: "https://www.ivoox.com/emprender-desde-universidad-ia-calidad-de-audios-mp3_rf_166631309_1.html"
      }
    ]
  },
  {
    source: "Spotify",
    logo: "/img/Spotify.png",
    description: "Plataforma global de streaming que amplifica contenidos digitales y divulgativos.",
    links: [
      {
        title: "Emprender desde la Universidad: IA y calidad de vida",
        url: "https://open.spotify.com/episode/3TutiPjzkvDaetVFd6gLJe?si=9bc1763df4334620&nd=1&dlsi=c315e9f245d64e01"
      }
    ]
  },
  {
    source: "IPFest",
    logo: "/img/IPFest.png",
    description: "Evento nacional de transferencia de conocimiento e innovación universitaria.",
    links: [
      {
        title: "Sparkling Tech, ganadores al premio a la Innovación en el  del IPFest 2025",
        url: "https://ipfest.es/finalista/84120"
      },
      {
        title: "Entrevista Sparkling Tech Solutions",
        url: "https://www.iptoday.tv/es/pv/426b1cc4-031c-81b1-700d-b07adbd78f70"
      }
    ]
  },
  {
    source: "Onda Fuerteventura",
    logo: "/img/OndaFuerteventura.png",
    description: "Emisora regional centrada en actualidad, emprendimiento y sociedad.",
    links: [
      {
        title: "Poli Suárez apuesta por una FP planificada en conexión con la realidad productiva de Canarias",
        url: "https://ondafuerteventura.es/poli-suarez-apuesta-por-una-fp-planificada-en-conexion-con-la-realidad-productiva-de-canarias"
      }
    ]
  },
  {
    source: "El Tambor",
    logo: "/img/tambor.png",
    description: "Medio digital canario especializado en actualidad regional y economía.",
    links: [
      {
        title: "Canarias refuerza su posicionamiento como plataforma atlántica de innovación en Málaga Transfiere 2026",
        url: "https://www.eltambor.es/canarias-refuerza-su-posicionamiento-como-plataforma-atlantica-de-innovacion-en-malaga-transfiere-2026/"
      }
    ]
  },
  {
    source: "Empresa Exterior",
    logo: "/img/empresaexterior.png",
    description: "Publicación enfocada en internacionalización y expansión empresarial.",
    links: [
      {
        title: "Canarias se consolida como plataforma tecnológica atlántica en el foro Málaga Transfiere 2026",
        url: "https://empresaexterior.com/art/101468/canarias-se-consolida-como-plataforma-tecnologica-atlantica-en-el-foro-malaga-transfiere-2026"
      },
      {
        title: "Canarias impulsa su industria tecnológica en el Foro Transfiere con una inversión potencial de 8,5 M€",
        url: "https://empresaexterior.com/art/101556/canarias-impulsa-su-industria-tecnologica-en-el-foro-transfiere-con-una-inversion-potencial-de-85-m"
      }
    ]
  },
  {
    source: "Canarias Noticias",
    logo: "/img/CanariasNoticias.png",
    description: "Medio digital dedicado a la actualidad social, económica y tecnológica del archipiélago.",
    links: [
      {
        title: "Día Internacional de la Mujer y la Niña en la Ciencia: el 56,8% de los matriculados en la ULPGC son mujeres",
        url: "https://canariasnoticias.es/2026/02/10/dia-internacional-de-la-mujer-y-la-nina-en-la-ciencia-el-568-de-los-matriculados-en-la-ulpgc-son-mujeres"
      }
    ]
  },
  {
    source: "Diario de Avisos",
    logo: "/img/diariodeavisos.png",
    description: "Uno de los principales periódicos de Canarias, referente en información regional.",
    links: [
      {
        title: "Canarias lleva su ‘ecosistema de innovación’ al foro Transfiere 2026",
        url: "https://diariodeavisos.elespanol.com/2026/02/canarias-foro-transfiere-2026-innovacion/"
      },
      {
        title: "Canarias despliega su proyección innovadora en Málaga Transfiere",
        url: "https://diariodeavisos.elespanol.com/2026/02/canarias-despliega-su-proyeccion-innovadora-en-malaga-transfiere/amp/"
      },
    ]
  },
  {
    source: "Nexotur",
    logo: "/img/nexotur.png",
    description: "Medio especializado en turismo, innovación y desarrollo empresarial.",
    links: [
      {
        title: "Canarias exhibirá su oferta tecnológica en la feria Málaga Transfiere",
        url: "https://nexotur.com/canarias-exhibira-su-oferta-tecnologica-en-la-feria-malaga-transfiere/"
      }
    ]
  },
  {
    source: "Tv La Palma",
    logo: "/img/tvlapalma.png",
    description: "El altavoz audiovisual de la identidad, la cultura y el talento palmero.",
    links: [
      {
        title: "Canarias despliega su proyección innovadora en Málaga Transfiere",
        url: "https://tvlapalma.com/not/41696/canarias-despliega-proyeccion-innovadora-malaga-transfiere/"
      }
    ]
  },
  {
    source: "Efe Servicios",
    logo: "/img/efe.png",
    description: "Agencia de comunicación integral y soluciones periodísticas personalizadas.",
    links: [
      {
        title: "Un centenar de profesionales ensalza en Transfiere el ecosistema de innovación de Canarias",
        url: "https://efs.efeservicios.com/video/centenar-profesionales-ensalza-transfiere-ecosistema-innovacion-canarias/7001550812"
      }
    ]
  },
  {
    source: "El Sur Digital Gran Canaria",
    logo: "/img/elsurdigital.jpg",
    description: "Medio digital canario especializado en actualidad regional y economía.",
    links: [
      {
        title: "Transformación digital, inteligencia artificial y ciberseguridad centran el programa de Digion Canarias 2026",
        url: "https://elsurdigitalgc.es/art/22102/transformacion-digital-inteligencia-artificial-y-ciberseguridad-centran-el-programa-de-digion-canarias-2026/"
      }
    ]
  },
  {
    source: "Gente Digital",
    logo: "/img/gente_digital.jpg",
    description: "Plataforma digital de comunicación y generación de contenidos para la comunidad.",
    links: [
      {
        title: "Transformación digital, IA y ciberseguridad centran los próximos 19 y 20 de marzo la cuarta edición del DigiON Canarias",
        url: "http://www.gentedigital.es/las-palmas-de-gran-canaria/noticia/4270463/transformacion-digital-ia-y-ciberseguridad-centran-los-proximos-19-y-20-de-marzo-la-cuarta-edicion-del-digion-canarias/"
      }
    ]
  },
  {
    source: "El Español",
    logo: "/img/el-espanol.png",
    description: "Medio de comunicación digital de referencia en información general y actualidad.",
    links: [
      {
        title: "Canarias presume de su potencial innovador para facilitar la transferencia de conocimientos entre continentes",
        url: "https://www.elespanol.com/invertia/disruptores/autonomias/canarias/20260220/canarias-presume-potencial-innovador-facilitar-transferencia-conocimientos-continentes/1003744137035_0.html"
      }
    ]
  },
  {
    source: "ABC",
    logo: "/img/logo-abc.png",
    description: "Periódico de referencia en información general y opinión con vocación centenaria.",
    links: [
      {
        title: "Un centenar de profesionales ensalza en Transfiere el ecosistema de innovación de Canarias",
        url: "https://www.abc.es/ciencia/centenar-profesionales-ensalza-transfiere-ecosistema-innovacin-canarias-20260225162630-vi.html?ref=https%3A%2F%2Fwww.abc.es%2Fciencia%2Fcentenar-profesionales-ensalza-transfiere-ecosistema-innovacin-canarias-20260225162630-vi.html"
      }
    ]
  },
  {
    source: "Europa press",
    logo: "/img/logo-europa-press.png",
    description: "Agencia de noticias líder en información general, económica y especializada.",
    links: [
      {
        title: "Transformación digital, IA y ciberseguridad centran los próximos 19 y 20 de marzo la cuarta edición del DigiON Canarias",
        url: "https://www.europapress.es/islas-canarias/noticia-transformacion-digital-ia-ciberseguridad-centran-proximos-19-20-marzo-cuarta-edicion-digion-canarias-20260303124356.html"
      }
    ]
  },
  {
    source: "msn",
    logo: "/img/MSN-Logo.png",
    description: "Plataforma de noticias y contenidos agregados con cobertura global.",
    links: [
      {
        title: "Canarias presume de su potencial innovador para facilitar la transferencia de conocimientos entre tres continentes",
        url: "https://www.msn.com/es-es/dinero/noticias/canarias-presume-de-potencial-innovador-para-facilitar-transferencia-de-conocimientos-entre-tres-continentes/ar-AA1WHZt1?apiversion=v2&domshim=1&noservercache=1&noservertelemetry=1&batchservertelemetry=1&renderwebcomponents=1&wcseo=1"
      }
    ]
  },
  {
    source: "La Gaceta de Gran Canaria",
    logo: "/img/gaceta-gc.png",
    description: "Medio de comunicación digital con enfoque en la actualidad de Gran Canaria.",
    links: [
      {
        title: "Canarias Futura dedica su segundo programa al sector de los videojuegos",
        url: "https://lagacetadegrancanaria.com/contenido/6578/canarias-futura-dedica-su-segundo-programa-al-sector-de-los-videojuegos"
      }
    ]
  },
  {
    source: "Fundación Universitaria de Las Palmas",
    logo: "/img/fulp.png",
    description: "Medio digital canario especializado en actualidad regional y economía.",
    links: [
      {
        title: "La FULP acoge la emisión de «Más de uno Canarias» con un especial del Programa Diginnova",
        url: "https://www.fulp.es/actualidad/noticias/la-fulp-acoge-la-emision-de-mas-de-uno-canarias-con-un-especial-del-programa"
      },
      {
        title: "Maica Amador, CEO de Sparkling Tech Solutions, valora la aportación de Diginnova a su empresa",
        url: "https://www.youtube.com/watch?v=g4jpvQlsIDA"
      },
      {
        title: "Instituciones, empresas y participantes ponen en valor el impacto de Diginnova en su tercera edición",
        url: "https://www.fulp.es/actualidad/noticias/instituciones-empresas-y-participantes-ponen-en-valor-el-impacto-de-diginnova"
      }
    ]
  },
  {
    source: "Onda Cero",
    logo: "/img/ondacero.png",
    description: "Medio digital canario especializado en actualidad regional y economía.",
    links: [
      {
        title: "Más de uno Canarias - Especial Diginnova",
        url: "https://www.ondacero.es/podcast/emisoras/las-palmas/mas-de-uno-canarias/mas-uno-canarias-16052025-especial-diginnova_202505166826cffe61200e0007e445cc.html"
      }
    ]
  },
  {
    source: "Startups Españolas",
    logo: "/img/StartupsEspanolas.png",
    description: "Plataforma que reúne a las startups más innovadoras de España.",
    links: [
      {
        title: "Videojuegos que detectan tu estrés y adaptan la dificultad en tiempo real",
        url: "https://startups-espanolas.es/sparkling-tech-solutions-videojuegos-que-detectan-tu-estres-y-adaptan-la-dificultad-en-tiempo-real/"
      }
    ]
  },
  {
    source: "Radio Faro del noreste",
    logo: "/img/RadioFaro.png",
    description: "Cadena de radio canaria especializada en actualidad regional y economía.",
    links: [
      {
        title: "Innovación en el Gobierno de Canarias",
        url: "https://www.radiofarodelnoroeste.es/gobierno-de-canarias/itemlist/tag/INNOVACI%C3%93N"
      }
    ]
  },
  {
    source: "Politican",
    logo: "/img/Politican.png",
    description: "Diario digital canario especializado en actualidad regional y economía.",
    links: [
      {
        title: "Transformación digital, inteligencia artificial y ciberseguridad centran el programa de DigiON Canarias 2026",
        url: "https://politican.es/nota/14351/transformacion-digital-inteligencia-artificial-y-ciberseguridad-centran-el-programa-de-digion-canarias-2026/"
      }
    ]
  },
  {
    source: "Canarias Excelencia Tecnológica",
    logo: "/img/CanariasExcelenciaTecnologica.png",
    description: "Portal de innovación y tecnología en Canarias.",
    links: [
      {
        title: "Sparkling Tech Solutions",
        url: "https://catalogo.canariasexcelenciatecnologica.com/catalogo/empresa/37"
      }
    ]
  },
  {
    source: "InfoNorte",
    logo: "/img/InfoNorte.png",
    description: "Diario digital del norte de Gran Canaria con información local y regional.",
    links: [
      {
        title: "DigiNova celebra la clausura de su tercera edición con un encuentro en la Fundación Universitaria de Las Palmas",
        url: "https://infonortedigital.com/art/190076/diginnova-celebra-la-clausura-de-su-tercera-edicion-con-un-encuentro-en-la-fundacion-universitaria-de-las-palmas"
      }
    ]
  },
];

const carouselData = [
  {
    src: "/img/carrusel_eventos/0a0334a7-be2d-429c-a7f2-065c254d5701.JPG",
    title: "Evento Top 101 Spain Up Nation 2025",
    subtitle: "Distinguida como una de las startups con mayor impacto en España."
  },
  {
    src: "/img/carrusel_eventos/99cbacec-d28d-40ba-aa62-20003a97dadf.JPG",
    title: "Colaboraciones",
    subtitle: "Fortaleciendo vínculos con el sector industrial y tecnológico de Canarias."
  },
  {
    src: "/img/carrusel_eventos/IMG_4167.JPG",
    title: "Charlas divulgadoras",
    subtitle: "Ciencia y tecnología explicadas de forma clara, accesible y cercana."
  },
  {
    src: "/img/carrusel_eventos/b70450a3-db7c-415a-85ae-7b4e599d870b.JPG",
    title: "Eventos tecnológicos",
    subtitle: "Compartiendo nuestra visión sobre videojuegos, IA, neurociencia y salud en foros especializados."
  },
  {
    src: "/img/carrusel_eventos/ce8059b1-3ab1-4c55-a6a7-84cac46a949b.JPG",
    title: "Tertulias científicas",
    subtitle: "Conversar para comprender."
  },
  {
    src: "/img/carrusel_eventos/cf1a740d-3579-4712-ba68-c4a2e1b8850f.JPG",
    title: "Foros de inversión",
    subtitle: "Tecnología deep tech basada en investigación aplicada, lista para escalar."
  },
  {
    src: "/img/carrusel_eventos/e2604155-95a4-4e7d-b078-9d9f95a37665.jpg",
    title: "Impulso internacional",
    subtitle: "Ciencia y tecnología desarrolladas en Canarias con proyección global."
  }
];

const CustomCarousel = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === data.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? data.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 7000);
    return () => clearInterval(timer);
  }, [currentIndex, data.length]);

  return (
    <div className="relative w-full h-[700px] overflow-hidden rounded-2xl shadow-2xl bg-black">
      <AnimatePresence>
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="absolute inset-0 w-full h-full"
        >
          <img
            src={data[currentIndex].src}
            alt={data[currentIndex].title}
            className="w-full h-full object-cover"
          />

          {/* Overlay and Text Content */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="absolute bottom-16 left-8 right-8 md:bottom-20 md:left-12 max-w-2xl text-white text-left"
          >
            <h3 className="text-3xl md:text-4xl font-bold mb-2 drop-shadow-lg">
              {data[currentIndex].title}
            </h3>
            <p className="text-lg md:text-xl text-white/90 drop-shadow-md">
              {data[currentIndex].subtitle}
            </p>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      {/* Navigation Dots */}
      <div className="absolute bottom-6 left-2/4 z-50 flex -translate-x-2/4 gap-3">
        {data.map((_, i) => (
          <span
            key={i}
            className={`block cursor-pointer rounded-full transition-all duration-300 ${currentIndex === i
              ? "w-10 h-2 bg-white"
              : "w-2 h-2 bg-white/40 hover:bg-white/60"
              }`}
            onClick={() => setCurrentIndex(i)}
          />
        ))}
      </div>

      {/* Arrow Controls */}
      <button
        onClick={prevSlide}
        className="absolute left-6 top-1/2 -translate-y-1/2 z-50 p-3 text-white bg-black/10 hover:bg-black/30 backdrop-blur-sm rounded-full transition-all hover:scale-110"
        aria-label="Previous slide"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-6 top-1/2 -translate-y-1/2 z-50 p-3 text-white bg-black/10 hover:bg-black/30 backdrop-blur-sm rounded-full transition-all hover:scale-110"
        aria-label="Next slide"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </button>
    </div>
  );
};

const AboutSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });

    // Espera un instante y luego sube al top
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
  }, []);

  const contentVariants = {
    initial: { opacity: 0, scale: 0.8, y: 100 },
    animate: { opacity: 1, scale: 1, y: 0 },
    exit: { opacity: 0, scale: 0.8, y: 100 },
  };

  return (
    <section className="about-new-section">
      <div className="no-margin-bottom">
        <div className="text-center mb-8 md:mb-10" data-aos="fade-up">
          <h1 className="text-4xl md:text-6xl font-black mb-6 tracking-tight mt-10">Conócenos</h1>
          <p className="text-muted-foreground text-lg md:text-2xl max-w-3xl mx-auto font-medium leading-relaxed" style={{
            fontSize: "1.25rem",
            lineHeight: "1.6",
            color: "#4b5563",
            maxWidth: "600px",
            margin: "0 auto",
            marginBottom: "60px"
          }}>
            Tecnología para el bienestar, la salud y el futuro
          </p>
        </div>

        <div className="about-intro-hero" data-aos="zoom-in">
          <div className="about-video-hero-wrapper">
            <video src="/videos/redcide.mp4#t=11" controls autoPlay muted loop className="cinematic-video" loading="lazy">
              Tu navegador no soporta el elemento de video.
            </video>
            <div className="video-glow-effect"></div>
          </div>
        </div>

        <div className="about-intro-text-columns" data-aos="fade-up" data-aos-delay="200" style={{ marginTop: "70px" }}>
          <div className="intro-column">
            <p>
              <strong>Sparkling Tech Solutions</strong> es una startup fundada en 2024. Está reconocida por <strong>ENISA </strong>como empresa emergente, acreditada con el sello <strong>Startup de la Universidad de Las Palmas de Gran Canaria (ULPGC)</strong> y avalada por el sello <strong>We Connect International,</strong> que certifica el liderazgo femenino de la compañía.
            </p>
            <p>
              En 2025, la empresa ha sido premiada en <strong>IPFEST</strong> como <strong>Mejor Startup Universitaria</strong>, tanto a nivel regional como nacional, y distinguida entre las <strong>Top 101 Spain Up Nation 2025</strong> como una de las startups con mayor impacto en España. Asimismo, ha sido mencionada por la revista <strong>El Referente</strong> como una de las empresas que liderarán el desarrollo de la Inteligencia Artificial en 2026, y ha recibido reconocimiento institucional por parte de <strong>FUNCATRA</strong>, poniendo en valor su contribución a la innovación, el empleo cualificado y el desarrollo tecnológico.
            </p>
            <p>
              Nuestra actividad se desarrolla en el ámbito de la <strong>investigación científica y técnica</strong>, alineada con la<strong> Estrategia RIS3+ de Canarias</strong>, contribuyendo al impulso de una <strong>innovación con impacto económico, social y territorial</strong>.
            </p>
          </div>
          <div className="intro-column">
            <p>
              Nos especializamos en el desarrollo de soluciones digitales basadas en investigación aplicada, integrando <strong>neurociencia, inteligencia artificial, videojuegos y tecnologías inmersivas</strong> para transformar el conocimiento científico en herramientas útiles, transferibles y escalables, aplicadas al ámbito de la salud y orientadas a fomentar un envejecimiento activo.
            </p>
            <p>
              En Sparkling Tech Solutions entendemos la tecnología como un medio para generar valor real. Por ello, todos nuestros proyectos se sustentan en el <strong>rigor científico, la ética tecnológica y un enfoque de innovación responsable</strong>, orientado a la transferencia de conocimiento y al desarrollo de soluciones basadas en evidencia.
            </p>
            <p>
              Colaboramos activamente con <strong>universidades, centros de investigación, clústeres, empresas e instituciones</strong>, participando en el diseño, validación y desarrollo de nuevos proyectos. Nuestro propósito es conectar ciencia, tecnología e innovación, impulsar iniciativas con impacto real y consolidarnos como un <strong>referente en el desarrollo de soluciones tecnológicas avanzadas</strong>, desde Canarias hacia el ámbito nacional e internacional.
            </p>
          </div>
        </div>
      </div>

      <section className="about-essencia-section" data-aos="fade-up">
        <div className="text-center mb-8 md:mb-10" style={{ marginTop: "-70px", marginBottom: "0px" }}>
          <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tight">Nuestra esencia</h2>
          <p className="text-muted-foreground text-lg md:text-2xl max-w-3xl mx-auto font-medium leading-relaxed" style={{
            fontSize: "1.25rem",
            lineHeight: "1.6",
            color: "#4b5563",
            maxWidth: "600px",
            margin: "0 auto"
          }}>Lo que nos mueve y hacia dónde caminamos</p>
        </div>

        {/*<div className="essencia-grid">
      <motion.div 
        className="essencia-card glass-card"
        whileHover={{ translateY: -10 }}
        data-aos="fade-right"
      >
        <div className="essencia-icon">🎯</div>
        <div className="essencia-content">
          <h3>Misión</h3>
          <p className="emphasis">Tecnología inclusiva con propósito</p>
          <p>
            Crear tecnología inclusiva y escalable que una ciencia, diseño y empatía para responder a necesidades reales.
          </p>
        </div>
      </motion.div>

      <motion.div 
        className="essencia-card glass-card"
        whileHover={{ translateY: -10 }}
        data-aos="fade-left"
      >
        <div className="essencia-icon">🌍</div>
        <div className="essencia-content">
          <h3>Visión</h3>
          <p className="emphasis">Investigación con impacto social</p>
          <p>
            Imaginar un futuro donde la investigación científica inspire soluciones aplicadas que transformen lo cotidiano con impacto social y sentido.
          </p>
        </div>
      </motion.div>
    </div>*/}
      </section>



      <section className="areas-carousel-section-about" data-aos="fade-up" style={{ marginTop: "-130px" }}>
        <CustomCarousel data={carouselData} />
      </section>



      <section data-aos="fade-up">
        <div className="about-mentions-section">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-4xl md:text-6xl font-black tracking-tight" style={{ marginBottom: "30px", marginTop: "-100px" }}>Así nos ven</h2>
            <p className="text-muted-foreground text-lg md:text-2xl max-w-3xl mx-auto font-medium leading-relaxed" style={{
              fontSize: "1.25rem",
              lineHeight: "1.6",
              color: "#4b5563",
              maxWidth: "600px",
              margin: "0 auto",
              marginBottom: "70px"
            }}>
              Medios, instituciones y entidades reconocen nuestro trabajo y trayectoria como proyecto innovador y de impacto social
            </p>
          </div>
          <div className="mentions-grid">
            {newsItems.map((news, index) => (
              <MorphingDialog
                key={index}
                transition={{
                  type: 'spring',
                  bounce: 0,
                  duration: 0.3,
                }}
              >
                <MorphingDialogTrigger className="news-trigger-item">
                  <MorphingDialogImage src={news.logo} alt={news.source} />
                </MorphingDialogTrigger>
                <MorphingDialogContainer>
                  <MorphingDialogContent className="news-dialog-content">
                    <div className="news-dialog-header">
                      <MorphingDialogImage src={news.logo} alt={news.source} className="news-dialog-logo" />
                    </div>

                    <MorphingDialogDescription
                      className="news-dialog-description"
                      variants={contentVariants}
                      disableLayoutAnimation
                    >
                      <p>{news.description}</p>
                    </MorphingDialogDescription>

                    <motion.div
                      className="news-links-container"
                      variants={contentVariants}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                    >
                      {news.links.map((link, lIndex) => (
                        <a key={lIndex} href={link.url} target="_blank" rel="noopener noreferrer" className="news-link-item">
                          {link.title}
                        </a>
                      ))}
                    </motion.div>

                    <MorphingDialogClose />
                  </MorphingDialogContent>
                </MorphingDialogContainer>
              </MorphingDialog>
            ))}
          </div>
        </div>
      </section>

      <section data-aos="fade-up" style={{ marginTop: "110px" }}>
        <div className="leadership-full-width">
          <div className="leadership-grid">
            <div className="leadership-visual" data-aos="fade-right">
              <div>
                <img src="/img/WomenOwned.png" alt="Women Owned Certified" />
              </div>
            </div>
            <div className="leadership-info" data-aos="fade-left">
              <h2 className="liderazgo-title">Liderazgo Femenino en Tecnología</h2>
              <p className="editorial-text">
                Sparkling Tech Solutions es una empresa <strong>liderada por mujeres</strong>, donde la perspectiva de género impulsa una innovación más humana e inclusiva.
              </p><br />
              <p className="editorial-text">
                Contamos con el sello <strong>Women Owned</strong>, el cual certifica internacionalmente que nuestra empresa es propiedad y está gestionada mayoritariamente por mujeres. Formamos parte de una red global que promueve el liderazgo femenino como motor de excelencia empresarial.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/*<section className="about-mentions-section success-cases" data-aos="fade-up">
  <div className="text-center mb-8 md:mb-10">
    <h2 className="text-4xl md:text-6xl font-black tracking-tight">Somos caso de éxito</h2>
  </div>
  <div className="about-block horizontal">
     <div className="exito-grid" data-aos="fade-left" data-aos-delay="0">
      
      <a href="">
      <video src="/videos/casoExitoFemepaCluster.mp4" controls autoPlay muted loop>
        Tu navegador no soporta el elemento de video.</video>
        </a>

        <a href="">
          <img src="/img/casoExitoCluster.png" alt="Somos caso de éxito para Cluster CET" />
        </a>
    </div>
  </div>
</section>*/}

      <section className="is-last" data-aos="zoom-in">
        <div className="cta-editorial-section mx-auto max-w-screen-xl lg:px-6">
          <div className="cta-header mx-auto text-center">
            <h2 className="cta-title font-black tracking-tight" style={{
              fontSize: "2.5rem",
              fontWeight: 900,
              background: "linear-gradient(135deg, #6366f1 0%, #a855f1 50%, #ec4899 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              color: "transparent",
              letterSpacing: "-0.02em",
              marginBottom: "1.5rem"
            }}>Ciencia, corazón y propósito</h2>
            <p className="cta-subtitle text-muted-foreground font-medium leading-relaxed" style={{
              fontSize: "1.125rem",
              lineHeight: "1.6",
              color: "#4b5563",
              maxWidth: "600px",
              margin: "1rem auto 2rem auto"
            }}>
              Sparkling Tech Solutions crea tecnología para la transformación social. Innovamos desde el conocimiento científico y el compromiso con el bienestar de las personas.
            </p>
            <Link
              to="/contacto"
              className="lit-up-button"
              style={{ marginBottom: "30px" }}
            >
              <div className="lit-up-border" />
              <div className="lit-up-content">
                Contáctanos
              </div>
            </Link>
          </div>
        </div>
      </section>
    </section>

  );
};

export default AboutSection;
